import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {
  adminArchiveRelease,
  adminGetReleaseNotes,
  adminPublishRelease,
  adminSaveRelease,
  adminSaveReleaseItem
} from "../common/api/WebApi";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import Footer from "../Footer";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import Meta from "../common/Meta";
import MDButton from "../../components/MDButton";
import PageLoading from "../common/PageLoading";
import ManageReleaseModal from "./ManageReleaseModal";
import ManageReleaseItemModal from "./ManageReleaseItemModal";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import NotificationItem from "../Items/NotificationItem";
import Confirm from "../common/Confirm";
import {Chip} from "@mui/material";

export default function ReleaseNotes(props) {

  const [context, setContext] = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [manageRelease, setManageRelease] = useState(false);

  const [confirmation, setConfirmation] = useState(null);
  const [saving, setSaving] = useState(false);

  const [archiveRelease, setArchiveRelease] = useState(false);
  const [publishRelease, setPublishRelease] = useState(false);
  const [release, setRelease] = useState(null);
  const [releases, setReleases] = useState([]);

  const handleConfirmArchive = async () => {
    setSaving(true);
    console.dir(release)
    let result = await adminArchiveRelease(release);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      adminGetReleaseNotesFn().then(()=>{
        setArchiveRelease(false);
        setConfirmation(null);
        setSaving(false);
      });
    }
  }

  const handleConfirmPublish = async () => {
    setSaving(true);
    console.dir(release)
    let result = await adminPublishRelease(release);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      adminGetReleaseNotesFn().then(()=>{
        setPublishRelease(false);
        setConfirmation(null);
        setSaving(false);
      });
    }
  }

  const publishReleaseFn = (release) => {
    setRelease(release);
    let confirmation = {
      title: release.status.id === 1 ? 'Publish Release?' : 'Unpublish Release?',
      message: 'Confirm ' + (release.status.id === 1 ? 'Publish Release?' : 'Unpublish Release?'),
      entity: release
    }
    setConfirmation(confirmation);
    setPublishRelease(true);
  }

  const archiveReleaseFn = (release) => {
      setRelease(release);
      let confirmation = {
        title: 'Delete Release?',
        message: 'Confirm delete release',
        entity: release
      }
      setConfirmation(confirmation);
      setArchiveRelease(true);
  }

  const adminGetReleaseNotesFn = async () => {
    let result = await adminGetReleaseNotes();
    if (result?.error) {
      // todo: handle error
    } else {
      setReleases(result);
      setLoading(false);
    }
  };
  const [searchCriteria, setSearchCriteria] = useState();

  const handleSearchChange = (e) => {
    setSearchCriteria(e.target.value);
  }

  const [savingRelease, setSavingRelease] = useState(false);

  const saveRelease = (release) => {
    setSavingRelease(true);
    adminSaveRelease(release).then((resp) => {
      setSavingRelease(false);
      setManageRelease(false);
      adminGetReleaseNotesFn();
    });
  }

  const saveReleaseItem = (releaseItem) => {
    setSavingRelease(true);
    let _item = {...releaseItem};
    console.dir(release);
    _item.releaseGuid = release?.guid;
    adminSaveReleaseItem(_item).then((resp) => {
      setSavingRelease(false);
      setManageReleaseItem(false);
      adminGetReleaseNotesFn();
    });
  }

  useEffect(() => {
    adminGetReleaseNotesFn();
  }, []);

  const [manageReleaseItem, setManageReleaseItem] = useState(false);
  const [releaseItem, setReleaseItem] = useState(null);

  const sortFn = (a, b)=> {
    const parse = v => v.name.replace(/^v/, '').split('.').map(Number);
    const [aParts, bParts] = [parse(a), parse(b)];

    for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
      const diff = (aParts[i] || 0) - (bParts[i] || 0);
      if (diff !== 0) return diff;
    }
    return 0;
  }


  const ReleaseNoteActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'release-note-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <span variant="contained" {...bindTrigger(popupState)}>
           <MDButton
             variant="outlined"
             color="secondary"
             size="small"
             circular
             iconOnly
           >
            <Icon>more_horiz</Icon>
          </MDButton>
          </span>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                setReleaseItem(null);
                setRelease(item);
                setManageReleaseItem(true)
              }} icon={<Icon>note</Icon>} title="Add Release Note"/>

            <NotificationItem
              onClick={(e) => {
                popupState.close();
                publishReleaseFn(item);
              }} icon={<Icon>{item.status.id === 1 ? 'visibility' : 'visibility_off'}</Icon>} title={item.status.id === 1 ? 'Publish' : 'Unpublish'}/>

            <NotificationItem
              onClick={(e) => {
                popupState.close();
                archiveReleaseFn(item);
              }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  return (
    <>
      <DashboardLayout>
        <Meta pageTitle={'Admin Release Notes'}/>
        <ContextSearchNavbar title={'Admin Release Notes'}/>
        <MDBox mt={4}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <MDBox pb={3}>
                <MDBox mb={3}>
                  <Card>
                    <MDBox p={3} lineHeight={1}>

                      <MDButton
                        onClick={() => {
                          setRelease(null);
                          setManageRelease(true)
                        }}
                        color="info"
                        size="small"
                        className="pull-right"
                        variant="contained">Add Release</MDButton>

                      <h5>
                        Release Notes
                      </h5>

                      {releases?.length > 0 && releases?.sort((a, b) => sortFn(b, a)).map((release, idx) => {
                        return (<div key={idx} style={{
                          border: 'solid 1px #ddd',
                          padding: '20px',
                          margin:'4px 0'
                        }}>
                          <span
                            className={'pull-right'}>

                                     <span className="d-block pull-right px-2 cursor-pointer">
                                        <ReleaseNoteActions item={release}/>
                                      </span>
                                    </span>

                          <h5>
                            <a href="#" onClick={(e) => {
                              e.preventDefault();
                              setRelease(release);
                              setManageRelease(true)
                            }}>{release.name} <Chip size='small' color={release.status.id === 1 ? 'primary' : 'secondary'} label={release.status.name} /> </a>
                          </h5>

                          <p>{release.description}</p>

                          <div  style={{
                            display:'block',
                            clear:'both'
                          }}>
                            {release?.releaseNotes?.length === 0 && <center>No Notes</center>}

                            {release?.releaseNotes?.length > 0 && <h6>Release Notes</h6>}
                            <ul className={'list-group'}>
                              {release?.releaseNotes?.sort((a, b) => a.noteId - b.noteId)?.map((item, idx) => {
                                return (
                                  <li key={idx} className={'list-group-item'}>
                                    <p>{item.title}</p>
                                    <small style={{
                                      whiteSpace: 'pre-wrap'
                                    }}>{item.description}</small>
                                    {item?.releaseNoteUrl &&
                                      <p className={'my-2'}>
                                        <a href={item.releaseNoteUrl} target={"_blank"}>
                                          {item.releaseNoteUrl}
                                        </a>
                                      </p>
                                    }
                                  </li>
                                )
                              })}
                            </ul>

                          </div>

                        </div>)
                      })}

                    </MDBox>

                  </Card>
                </MDBox>

                {loading && <PageLoading/>}

              </MDBox>
            </Grid>
          </Grid>
        </MDBox>

        <Footer mt={5}/>

      </DashboardLayout>

      {archiveRelease && <>
        <Confirm confirmation={confirmation}
                 show={archiveRelease}
                 saving={saving}
                 handleConfirm={handleConfirmArchive}
                 handleSave={()=>{
                   setConfirmation(null);
                   setArchiveRelease(false);
                 }} />
      </>}

      {publishRelease && <>
      <Confirm confirmation={confirmation}
               show={publishRelease}
               saving={saving}
               handleConfirm={handleConfirmPublish}
               handleSave={()=>{
                 setConfirmation(null);
                 setPublishRelease(false);
               }} />
    </>}

      {manageRelease && <>
        <ManageReleaseModal
          key={release}
          release={release}
          saving={savingRelease}
          handleSave={(data) => {
            saveRelease(data)
          }}
          handleClose={() => {
            setManageRelease(false);
          }}
          show={manageRelease}
        />
      </>}

      {manageReleaseItem && <>
        <ManageReleaseItemModal
          key={releaseItem}
          releaseItem={releaseItem}
          saving={savingRelease}
          handleSave={(data) => {
            saveReleaseItem(data)
          }}
          handleClose={() => {
            setManageReleaseItem(false);
          }}
          show={manageReleaseItem}
        />
      </>}

    </>
  );
}